import { format } from "date-fns";

export const formatActivityGroupDate = (date: string) => {
  return format(new Date(date), "MMMM yyyy");
};
export const formatActivityItemDate = (date: string | null) => {
  return date ? format(new Date(date), "EEE dd/MM") : "";
};
